<div class="verification-container" [@fadeIn]>

  <!-- Main Content -->
  <div class="verification-content">
    <div class="verification-content__inner" [@slideInUp]>

      <!-- Header avec icône -->
      <div class="verification-header">
        <div class="verification-header__icon" aria-hidden="true">
          <i class="pi pi-shield"></i>
        </div>
        <h1 class="verification-header__title">{{ 'VERIFICATION.TITLE' | translate }}</h1>
        <p class="verification-header__subtitle" *ngIf="emailOrTel">
          {{ 'VERIFICATION.SUBTITLE' | translate }}
          <span class="verification-header__contact">{{ formatContact(emailOrTel) }}</span>
        </p>
      </div>

      <!-- Verification Form avec animation -->
      <form [formGroup]="verificationForm" (ngSubmit)="onSubmit()" class="verification-form" novalidate [@formSlide]>

        <!-- Code Inputs (7 fields, alignés avec l'OTP backend) -->
        <div class="verification-form__inputs" role="group"
          [attr.aria-label]="'VERIFICATION.CODE_INPUT_GROUP' | translate"
          [class.verification-form__inputs--error]="hasError"
          [class.verification-form__inputs--success]="isFormValid && !isLoading">

          <input #codeInput type="text" inputmode="numeric" pattern="\d*" maxlength="1" formControlName="code1"
            (input)="onCodeInput($event, 0)" (keydown)="onCodeKeyDown($event, 0)" (paste)="onCodePaste($event)"
            (focus)="onInputFocus(0)" autocomplete="one-time-code"
            [attr.aria-label]="('VERIFICATION.DIGIT_LABEL' | translate) + ' 1'" [attr.aria-required]="true"
            [attr.aria-invalid]="hasError" class="verification-form__input"
            [class.verification-form__input--filled]="verificationForm.get('code1')?.value"
            [class.verification-form__input--error]="hasError"
            [class.verification-form__input--success]="isFormValid && !isLoading" />

          <input #codeInput type="text" inputmode="numeric" pattern="\d*" maxlength="1" formControlName="code2"
            (input)="onCodeInput($event, 1)" (keydown)="onCodeKeyDown($event, 1)" (paste)="onCodePaste($event)"
            (focus)="onInputFocus(1)" autocomplete="one-time-code"
            [attr.aria-label]="('VERIFICATION.DIGIT_LABEL' | translate) + ' 2'" [attr.aria-required]="true"
            [attr.aria-invalid]="hasError" class="verification-form__input"
            [class.verification-form__input--filled]="verificationForm.get('code2')?.value"
            [class.verification-form__input--error]="hasError"
            [class.verification-form__input--success]="isFormValid && !isLoading" />

          <input #codeInput type="text" inputmode="numeric" pattern="\d*" maxlength="1" formControlName="code3"
            (input)="onCodeInput($event, 2)" (keydown)="onCodeKeyDown($event, 2)" (paste)="onCodePaste($event)"
            (focus)="onInputFocus(2)" autocomplete="one-time-code"
            [attr.aria-label]="('VERIFICATION.DIGIT_LABEL' | translate) + ' 3'" [attr.aria-required]="true"
            [attr.aria-invalid]="hasError" class="verification-form__input"
            [class.verification-form__input--filled]="verificationForm.get('code3')?.value"
            [class.verification-form__input--error]="hasError"
            [class.verification-form__input--success]="isFormValid && !isLoading" />

          <input #codeInput type="text" inputmode="numeric" pattern="\d*" maxlength="1" formControlName="code4"
            (input)="onCodeInput($event, 3)" (keydown)="onCodeKeyDown($event, 3)" (paste)="onCodePaste($event)"
            (focus)="onInputFocus(3)" autocomplete="one-time-code"
            [attr.aria-label]="('VERIFICATION.DIGIT_LABEL' | translate) + ' 4'" [attr.aria-required]="true"
            [attr.aria-invalid]="hasError" class="verification-form__input"
            [class.verification-form__input--filled]="verificationForm.get('code4')?.value"
            [class.verification-form__input--error]="hasError"
            [class.verification-form__input--success]="isFormValid && !isLoading" />

          <input #codeInput type="text" inputmode="numeric" pattern="\d*" maxlength="1" formControlName="code5"
            (input)="onCodeInput($event, 4)" (keydown)="onCodeKeyDown($event, 4)" (paste)="onCodePaste($event)"
            (focus)="onInputFocus(4)" autocomplete="one-time-code"
            [attr.aria-label]="('VERIFICATION.DIGIT_LABEL' | translate) + ' 5'" [attr.aria-required]="true"
            [attr.aria-invalid]="hasError" class="verification-form__input"
            [class.verification-form__input--filled]="verificationForm.get('code5')?.value"
            [class.verification-form__input--error]="hasError"
            [class.verification-form__input--success]="isFormValid && !isLoading" />

          <input #codeInput type="text" inputmode="numeric" pattern="\d*" maxlength="1" formControlName="code6"
            (input)="onCodeInput($event, 5)" (keydown)="onCodeKeyDown($event, 5)" (paste)="onCodePaste($event)"
            (focus)="onInputFocus(5)" autocomplete="one-time-code"
            [attr.aria-label]="('VERIFICATION.DIGIT_LABEL' | translate) + ' 6'" [attr.aria-required]="true"
            [attr.aria-invalid]="hasError" class="verification-form__input"
            [class.verification-form__input--filled]="verificationForm.get('code6')?.value"
            [class.verification-form__input--error]="hasError"
            [class.verification-form__input--success]="isFormValid && !isLoading" />

          <input #codeInput type="text" inputmode="numeric" pattern="\d*" maxlength="1" formControlName="code7"
            (input)="onCodeInput($event, 6)" (keydown)="onCodeKeyDown($event, 6)" (paste)="onCodePaste($event)"
            (focus)="onInputFocus(6)" autocomplete="one-time-code"
            [attr.aria-label]="('VERIFICATION.DIGIT_LABEL' | translate) + ' 7'" [attr.aria-required]="true"
            [attr.aria-invalid]="hasError" class="verification-form__input"
            [class.verification-form__input--filled]="verificationForm.get('code7')?.value"
            [class.verification-form__input--error]="hasError"
            [class.verification-form__input--success]="isFormValid && !isLoading" />
        </div>

        <!-- Timer avec animation et progress -->
        <div class="verification-form__timer" *ngIf="!canResend" [@slideDown] role="timer" aria-live="polite">
          <div class="verification-form__timer-icon">
            <i class="pi pi-clock" aria-hidden="true"></i>
          </div>
          <div class="verification-form__timer-content">
            <span class="verification-form__timer-label">{{ 'VERIFICATION.TIME_REMAINING' | translate }}</span>
            <span class="verification-form__timer-value">{{ countdownFormatted }}</span>
          </div>
          <!-- Progress bar -->
          <div class="verification-form__timer-progress" aria-hidden="true">
            <div class="verification-form__timer-bar" [style.width.%]="(countdown / 60) * 100">
            </div>
          </div>
        </div>

        <!-- Info Message avec icône -->
        <!-- <div class="verification-form__info" *ngIf="emailOrTel" [@fadeIn]>
          <i class="pi pi-info-circle" aria-hidden="true"></i>
          <p>
            {{ 'VERIFICATION.INFO_MESSAGE' | translate }}
            <strong class="verification-form__contact">{{ formatContact(emailOrTel) }}</strong>
          </p>
        </div> -->

        <!-- Messages d'erreur -->
        <div class="verification-form__error" *ngIf="hasError && errorMessage" [@errorSlide] role="alert"
          aria-live="assertive">
          <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
          <span>{{ errorMessage }}</span>
        </div>

        <!-- Submit Button (caché car auto-submit) -->
        <p-button type="submit" [label]="'VERIFICATION.VERIFYING' | translate" [loading]="isLoading"
          [disabled]="!isFormValid || isLoading" [icon]="isLoading ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
          iconPos="right" styleClass="w-full verification-form__submit" *ngIf="isLoading"></p-button>
      </form>

      <!-- Resend Code -->
      <div class="verification-footer">
        <p class="verification-footer__text">
          {{ 'VERIFICATION.DIDNT_RECEIVE' | translate }}
        </p>
        <button type="button" class="verification-footer__resend"
          [class.verification-footer__resend--disabled]="!canResend || isResending"
          [disabled]="!canResend || isLoading || isResending" (click)="onResendCode()"
          [attr.aria-disabled]="!canResend || isLoading || isResending" tabindex="0">
          <i class="pi pi-refresh" [class.pi-spin]="isResending" aria-hidden="true"></i>
          <span>{{ isResending ? ('VERIFICATION.RESENDING' | translate) : ('VERIFICATION.RESEND_CODE' | translate)
            }}</span>
        </button>

        <!-- Divider -->
        <div class="verification-footer__divider" aria-hidden="true"></div>

        <!-- Back to login -->
        <button type="button" class="verification-footer__back" (click)="onBack()" tabindex="0">
          <i class="pi pi-arrow-left" aria-hidden="true"></i>
          <span>{{ 'VERIFICATION.BACK_TO_LOGIN' | translate }}</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Desktop Visual avec animations améliorées -->
  <div class="verification-visual" role="complementary" aria-label="Verification visual" [@fadeIn]>
    <div class="verification-visual__content">
      <!-- Animation background -->
      <div class="verification-visual__animation" aria-hidden="true">
        <div class="verification-visual__circle verification-visual__circle--red"></div>
        <div class="verification-visual__circle verification-visual__circle--green"></div>
        <div class="verification-visual__gradient"></div>
      </div>

      <!-- Content -->
      <div class="verification-visual__text">
        <div class="verification-visual__icon">
          <i class="pi pi-shield" aria-hidden="true"></i>
        </div>
        <h2 class="verification-visual__title">{{ 'VERIFICATION.VISUAL_TITLE' | translate }}</h2>
        <p class="verification-visual__subtitle">{{ 'VERIFICATION.VISUAL_SUBTITLE' | translate }}</p>

        <!-- Security badges -->
        <div class="verification-visual__badges" role="list">
          <div class="verification-visual__badge" role="listitem">
            <i class="pi pi-lock" aria-hidden="true"></i>
            <span>{{ 'VERIFICATION.BADGE_SECURE' | translate }}</span>
          </div>
          <div class="verification-visual__badge" role="listitem">
            <i class="pi pi-clock" aria-hidden="true"></i>
            <span>{{ 'VERIFICATION.BADGE_FAST' | translate }}</span>
          </div>
          <div class="verification-visual__badge" role="listitem">
            <i class="pi pi-verified" aria-hidden="true"></i>
            <span>{{ 'VERIFICATION.BADGE_VERIFIED' | translate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Toast Messages handled globally by AppComponent -->


  <!-- Success overlay -->
  <div class="verification-success-overlay" *ngIf="isSuccess" [@successFade]>
    <div class="verification-success-overlay__content">
      <div class="verification-success-overlay__icon">
        <i class="pi pi-check-circle" aria-hidden="true"></i>
      </div>
      <h3>{{ 'VERIFICATION.SUCCESS_TITLE' | translate }}</h3>
      <p>{{ 'VERIFICATION.SUCCESS_MESSAGE' | translate }}</p>
    </div>
  </div>
</div>